import { Avatar, Button, Popper, PopperButton } from "@pinkyhead/dovekit";
import { UserContainer } from "../Search/User/User.styles";
import { useUser } from "./User.hooks"
import { AvatarContainer, ButtonContainer, Container, PopperContainer } from "./User.styles";

export const User = () => {
  const {
    redirectToLoginPage,
    popperOpen,
    togglePopperOpen,
    user,
    logout,
    redirectToCoreProfile
  } = useUser();
  return (
    <Container>
      {user
        ? 
          <Popper
            popperOpen={popperOpen}
            togglePopperOpen={togglePopperOpen}
            iconComponent={
              <AvatarContainer>
                <Avatar 
                  displayName={user.displayName}
                  size={60}
                  fontSize={16}
                  picture={null}
                />
              </AvatarContainer>
            }
            >
              <PopperContainer>
                <UserContainer>
                  <Avatar 
                    displayName={user.displayName}
                    size={60}
                    fontSize={16}
                    picture={null}
                  />
                  <h3>{user.displayName}</h3>
                </UserContainer>
                <PopperButton onClick={redirectToCoreProfile}>
                  Go to My DoveMed Profile
                </PopperButton>
                <Button
                  fullWidth 
                  variant="secondary"
                  onClick={logout}
                >
                  Logout
                </Button>
              </PopperContainer>
          </Popper>
        : 
          <ButtonContainer>
            <Button
              onClick={redirectToLoginPage}
              variant="secondary"
              size="small"
            >
              Get started
            </Button>
          </ButtonContainer>
      }
    </Container>
  )
}
